module.exports = __webpack_public_path__ + "static/media/BAND-FTM.c7b078a7.png";